import * as React from 'react';
import { Redirect } from 'react-router-dom';

import NavBar from '../../../components/CustomNav/CustomNav.Component';
import { StyledRow, VideoContainer } from './PostPayment.styles';
import { Container, Footer } from '../Common/Common.styles';
import withServices from '../../../HOCs/withServices';

import Vimeo from '@u-wave/react-vimeo';
import VideoPlayer from 'src/components/VideoPlayer/VideoPlayer';

interface IProps {
  services?: any;
  history?: any;
}

interface IState {
  navigate: boolean;
  destination: string;
}

class PostPayment extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      destination: '',
      navigate: false
    }

    this.onLogout = this.onLogout.bind(this);
    this.toDashboard = this.toDashboard.bind(this);
    this.toResources = this.toResources.bind(this);
  }


  public async componentDidMount() {
    // check if logged in
    // fetch any required data
    // check if already upgraded

  }

  public onLogout() {
    this.setState({ navigate: true, destination: '/login' });
  }
  public toResources() {
    // alert("to resources")
  }

  public toDashboard() {
    // alert('to dashboard');
  }

  public render() {
    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />
    }

    return (
      <Container>
        <NavBar logoutParent={this.onLogout} />
        <StyledRow>
          <h1 className="postpayment-title">
            Welcome to Performance Learning <span>Current User</span>
          </h1>
          <h2 className="postpayment-description">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. In
            beatae deleniti.
          </h2>

          <VideoContainer borderColor="#ff0033">
            <div className="descript-wrapper">
              <h3 className="video-title">Lorem, ipsum Dolor.</h3>
              <p className="video-descript">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea
                saepe dolorem quo, ipsum labore optio.
              </p>
            </div>
            <div className="vid-wrapper">
              <VideoPlayer videoId="250113494" width="100%" height="100%" />
            </div>
          </VideoContainer>

          <VideoContainer borderColor="#acff24">
            <div className="descript-wrapper">
              <h3 className="video-title">Lorem, ipsum Dolor.</h3>
              <p className="video-descript">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea
                saepe dolorem quo, ipsum labore optio.
              </p>
            </div>
            <div className="vid-wrapper">
              <VideoPlayer videoId="250113494" width="100%" height="100%" />
            </div>
          </VideoContainer>

          <VideoContainer borderColor="#3ee9f7">
            <div className="descript-wrapper">
              <h3 className="video-title">Lorem, ipsum Dolor.</h3>
              <p className="video-descript">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea
                saepe dolorem quo, ipsum labore optio.
              </p>
            </div>
            <div className="vid-wrapper">
              <VideoPlayer videoId="250113494" width="100%" height="100%" />
            </div>
          </VideoContainer>

          <VideoContainer borderColor="#ff0033">
            <div className="descript-wrapper">
              <h3 className="video-title">Lorem, ipsum Dolor.</h3>
              <p className="video-descript">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea
                saepe dolorem quo, ipsum labore optio.
              </p>
            </div>
            <div className="vid-wrapper">
              <VideoPlayer videoId="50113494" />
            </div>
          </VideoContainer>

          <p className="checkout-more">
            Checkout more Performance Learning resources{" "}
            <span onClick={this.toResources}>here</span>
          </p>

          <Footer>
            <button
              className="blue-button continue"
              onClick={this.toDashboard}
            >
              Continue
            </button>
          </Footer>
        </StyledRow>
      </Container>
    );
  }
}

export default withServices(PostPayment);


// WEBPACK FOOTER //
// ./src/pages/Onboard/PostPayment/PostPayment.Component.tsx